
(function(){
  function setupWpcCards(){
    document.querySelectorAll('[data-pc-wpc-card]').forEach(function(card){
      if(card.dataset.pcQuickReady==='1')return;
      card.dataset.pcQuickReady='1';
      var button=card.querySelector('[data-pc-wpc-card-add]');
      var status=card.querySelector('[data-pc-wpc-card-feedback]');
      if(!button)return;
      button.addEventListener('click',function(){
        var api=window.PCPreviewCart;
        if(!api){if(status)status.textContent='Preview basket is loading. Please retry.';return;}
        var item={
          code:card.dataset.pcPreviewCode,
          title:card.dataset.pcPreviewTitle,
          price:Number(card.dataset.pcPreviewPrice),
          image:card.dataset.pcPreviewImage
        };
        if(api.add(item,1)){
          if(status)status.textContent='Added to basket · '+api.count()+' item(s)';
          button.classList.add('is-added');
          button.textContent='✓ Added to Cart';
        }else if(status){status.textContent='Could not save this product to your preview basket.';}
      });
    });
  }
  function setupWpcDetail(){
    var url=new URL(window.location.href);
    var code=url.searchParams.get('wpc_preview');
    if(!code)return;
    var root=document.querySelector('[data-pc-wpc-detail-pages]');
    if(!root)return;
    var all=root.querySelectorAll('[data-pc-wpc-detail]');
    var selected=null;
    for(var i=0;i<all.length;i++){
      var match=all[i].getAttribute('data-pc-wpc-detail')===code;
      all[i].hidden=!match;
      if(match)selected=all[i];
    }
    if(!selected){document.documentElement.classList.remove('pc-wpc-detail-view');return;}
    document.documentElement.classList.add('pc-wpc-detail-view');
    var mainImg=selected.querySelector('[data-wpc-main-image]');
    selected.querySelectorAll('[data-wpc-thumb]').forEach(function(button){
      button.addEventListener('click',function(){
        var image=button.getAttribute('data-wpc-thumb');
        if(mainImg && image)mainImg.src=image;
        selected.querySelectorAll('[data-wpc-thumb]').forEach(function(other){
          var on=other===button;
          other.classList.toggle('is-active',on);
          other.setAttribute('aria-pressed',on?'true':'false');
        });
      });
    });
    var thumbnails=Array.prototype.slice.call(selected.querySelectorAll('[data-wpc-thumb]'));
    var selectedIndex=0;
    function slideBy(delta){
      if(!thumbnails.length)return;
      selectedIndex=(selectedIndex+delta+thumbnails.length)%thumbnails.length;
      thumbnails[selectedIndex].click();
    }
    thumbnails.forEach(function(thumb,i){thumb.addEventListener('click',function(){selectedIndex=i;});});
    var prev=selected.querySelector('[data-wpc-gallery-prev]');
    var next=selected.querySelector('[data-wpc-gallery-next]');
    if(prev)prev.addEventListener('click',function(){slideBy(-1);});
    if(next)next.addEventListener('click',function(){slideBy(1);});
    var qty=selected.querySelector('[data-wpc-quantity]');
    var minus=selected.querySelector('[data-wpc-qty-minus]');
    var plus=selected.querySelector('[data-wpc-qty-plus]');
    if(qty&&minus&&plus){
      minus.addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1);});
      plus.addEventListener('click',function(){qty.value=Math.min(999,(parseInt(qty.value,10)||1)+1);});
    }
    var addButton=selected.querySelector('[data-pc-preview-add]');
    var feedback=selected.querySelector('[data-pc-added-feedback]');
    if(addButton){
      addButton.addEventListener('click',function(){
        var api=window.PCPreviewCart;
        if(!api){
          if(feedback)feedback.textContent='Preview cart is still loading. Please try again.';
          return;
        }
        var item={
          code:selected.getAttribute('data-pc-wpc-detail'),
          title:selected.getAttribute('data-pc-preview-title'),
          image:selected.getAttribute('data-pc-preview-image'),
          price:Number(selected.getAttribute('data-pc-preview-price'))
        };
        var requested=Math.min(999,Math.max(1,parseInt(qty&&qty.value,10)||1));
        var outcome=api.add(item,requested);
        if(outcome){
          var count=api.count();
          if(feedback)feedback.textContent=requested+' panel'+(requested===1?'':'s')+' added to your preview basket. Basket total: '+count+' item'+(count===1?'':'s')+'.';
          addButton.classList.add('is-added');
          addButton.innerHTML='Added to basket <span aria-hidden="true">✓</span>';
        }else if(feedback){
          feedback.textContent='Could not save your preview item in this browser.';
        }
      });
    }
    var totalEl=selected.querySelector('[data-pc-wpc-total]');
    function updateSelectedTotal(){
      if(!totalEl)return;
      var price=Number(selected.getAttribute('data-pc-preview-price'));
      var quantity=Math.min(999,Math.max(1,Math.floor(Number(qty&&qty.value)||1)));
      if(qty)qty.value=quantity;
      totalEl.textContent='£'+(price*quantity).toFixed(2);
    }
    if(qty){
      qty.addEventListener('input',updateSelectedTotal);
      qty.addEventListener('change',updateSelectedTotal);
    }
    if(minus)minus.addEventListener('click',updateSelectedTotal);
    if(plus)plus.addEventListener('click',updateSelectedTotal);
    updateSelectedTotal();
    window.scrollTo(0,0);
  }
  function mergePvcCards(){
    var search=new URLSearchParams(window.location.search);
    if(search.has('wpc_preview')||search.has('pvc_preview'))return;
    var wpcGrid=document.querySelector('.pc-wpc-preview__grid');
    var pvcSection=document.querySelector('[data-pc-pvc-preview]');
    var pvcGrid=pvcSection&&pvcSection.querySelector('.pc-pvc-preview__grid');
    if(!wpcGrid||!pvcGrid)return;
    Array.prototype.slice.call(pvcGrid.querySelectorAll('[data-pc-pvc-card]')).forEach(function(card){
      wpcGrid.appendChild(card);
    });
    pvcSection.classList.add('is-merged');
    var heading=document.querySelector('.pc-wpc-preview__intro h2');
    if(heading)heading.textContent='WPC & PVC Wall Panels';
    var link=document.querySelector('.pc-wpc-preview__intro .pc-wpc-preview__all');
    if(link)link.textContent='Explore WPC & PVC panels ↗';
    var intro=document.querySelector('.pc-wpc-preview__intro .pc-wpc-preview__desc');
    if(intro)intro.textContent='Explore our WPC and PVC wall panels together. Select any finish to see its photos, dimensions and product details.';
  }
  function boot(){setupWpcCards();setupWpcDetail();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
